export default function (hashName) {
    if (process.browser) {
        window.location.hash = `#${hashName}`;
    }
}
